import { useEffect, useRef } from 'react';

import { useVisibleElement, useVisibilityChange } from './index';

export const useVisibleDuration = (elem, callback: (duration: number) => void) => {
  const refStartVisibleTime = useRef(0);
  const refDuration = useRef(0);
  const hasBeenCallback = useRef(false);
  const { visible } = useVisibleElement(elem, true);

  useVisibilityChange(
    (focus) => {
      if (!focus && visible) {
        if (refStartVisibleTime.current) {
          refDuration.current =
            Date.now() - refStartVisibleTime.current + refDuration.current;
          callback(refDuration.current);
        }
      } else if (visible) {
        refStartVisibleTime.current = Date.now();
      }
    },
    [visible],
  );

  useEffect(() => {
    if (visible) {
      refStartVisibleTime.current = Date.now();
    } else if (refStartVisibleTime.current) {
      refDuration.current =
        Date.now() - refStartVisibleTime.current + refDuration.current;
      callback(refDuration.current);
    }
  }, [visible]);

  useEffect(
    () => () => {
      if (refStartVisibleTime.current && refDuration.current == 0) {
        callback(Date.now() - refStartVisibleTime.current + refDuration.current);
      }
    },
    [],
  );

  return visible;
};
